const $$splitComponentImporter = () => import('/app/apps/webapp/src/app/routes/_authenticated/onboarding.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
export const Route = createFileRoute('/_authenticated/onboarding')({
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});